import { config_settings } from '@/config.js';
import Vue from 'vue';

const baseApiUrl = config_settings.RESOURCE_SERVER_URL;

export const getProductsToHome = () => {
  return Vue.$http.get(baseApiUrl + '/GET/catalog/products');
};

export const getOfferProductsToHome = () => {
  return Vue.$http.get(baseApiUrl + '/GET/catalog/products/offers');
};

export const getSubProductswDiscount = () => {
  return Vue.$http.get(baseApiUrl + '/GET/catalog/products/subproducts');
};

export const updateVisitProductRating = (code) => {
  return Vue.$http({
    method: 'put',
    url: config_settings.RESOURCE_SERVER_URL + '/PUT/catalog/products/' + code + '/views',
  });
};
